import { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { InviteMemberModal } from './invite-member-modal';
import { MembersTable } from './member-table';
import { OrganizationInfo } from '../organization/organization-info';
import { useAtomValue } from 'jotai';
import { organizationDataAtom } from '@/store';

export const Members = () => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedOrganization = useAtomValue(organizationDataAtom);

  return (
    <div className='space-y-6'>
      <Card className='w-full !bg-transparent border-none shadow-none'>
        <CardContent className='p-0 space-y-6'>
          <div className='space-y-6'>
            <div>
              <h2 className='text-lg font-semibold text-gray-900 mb-4'>Organization Details</h2>
              <OrganizationInfo />
            </div>
            
            <div>
              <h2 className='text-lg font-semibold text-gray-900 mb-4'>Team Members</h2>
              <MembersTable onInviteClick={() => setIsOpen(true)} />
            </div>
          </div>
        </CardContent>
      </Card>
      {selectedOrganization && (
        <InviteMemberModal 
          isOpen={isOpen} 
          onClose={() => setIsOpen(false)} 
          organizationId={selectedOrganization.id}
        />
      )}
    </div>
  );
};
